export default __webpack_public_path__ + "static/media/fablab4.4d1c13cf.jpg";